import Box from '@mui/material/Box';
import { CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { AgColor } from '../Styles/AgColor';

export default function AgLoading({ CircularLoading }:{CircularLoading?: boolean}) {
  const [backgroundColors, setBackgroundColors] = useState(Array(6).fill(AgColor.secondaryLight2));
  let i = 0;

  const clear = () => {
    setTimeout(()=> {
      setBackgroundColors(Array(6).fill(AgColor.secondaryLight2));
      i = -1;  
    }, 500);
  };

  const myLoop = () => {
    if (i === backgroundColors.length) clear();
    const arr = [...backgroundColors];
    if(i < backgroundColors.length && i >= 0){
      arr[i-1] = AgColor.secondaryLight2;
      arr[i] = AgColor.secondaryMain;
    }
    setTimeout(()=> {
      setBackgroundColors(arr);
      i++;
      if (i <= backgroundColors.length ) {
        myLoop();
      }
    }, 500);
  };

  useEffect(()=>{
    myLoop(); 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return CircularLoading ?
    <CircularProgress />
    :
    <Box>
      <Box 
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '0px 8px',
          gap: '6px',
          width: '94px',
          height: '48px'
        }}>
        {backgroundColors.map((backgroundColor, index) => {
          return <Box key={index}
            style={{
              width: '8px',
              height: '8px',
              background: backgroundColor,
              transform: 'rotate(180deg)',
              flex: 'none',
              order: '0',
              flexGrow: '0',
              borderRadius: '5px'
            }}></Box>;
        })}
      </Box>
      
    </Box>;
  ;
}